import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    saveAllList:[],
    audioShow:1,
  },
  mutations: {
    audioShow_vuex(state,data){
    // console.log("state,data",state,data);
     state.audioShow = data
   }
  },
  actions: {

  },
  
})



// WEBPACK FOOTER //
// ./src/store/index.js